import React, { useCallback, useEffect, useState } from "react";
import MainFooterComponent from "common/components/MainFooterComponent/MainFooterComponent";
import GameHeader from "common/components/GameHeader/GameHeader";
import StudentFolderHeader from "features/studentFolder/components/StudentFolderHeader/StudentFolderHeader";
import StudentTable from "features/studentFolder/components/StudentTable/StudentTable";
import Accordion from "react-bootstrap/Accordion";
import Tab from "react-bootstrap/Tab";

import "./StudentFolder.scss";
import { useTypedDispatch } from "store";
import { getStudentFolder, setLevels } from "store/game/thunkActions";

import { setGame, setGameMultiple } from "store/game/slice";
import { useNavigate } from "react-router-dom";
import StudentFolderMobile from "./StudentFolderMobile";
import ModalExpiredGame from "features/game/components/ModalExpiredGame/ModalExpiredGame";
import { validExercise } from "features/studentFolder/helpers/validExercise.helper";
import { showMobile } from "helpers/adaptation";

export type GameTypeStudent =
  | "bidding"
  | "handPlay"
  | "deffense"
  | "tricks"
  | "defLead"
  | "miniBridge";

function StudentFolder() {
  const dispatch = useTypedDispatch();
  const [activeLesson, setActiveLesson] = useState(0);
  const [activeTab, setActiveTab] = useState<GameTypeStudent>("bidding");
  const [data, setData] = useState({
    handPlay: [],
    bidding: [],
    deffense: [],
    tricks: [],
    defLead: [],
    miniBridge: []
  });
  const [searchData, setSearchData] = useState<any>([]);
  const [search, setSearch] = useState("");
  const [isExpiredUser, setIsExpiredUser] = useState(false);

  const navigate = useNavigate();

  const onChangeTab = useCallback(
    async (type: GameTypeStudent) => {
      try {
        setActiveTab(type);
        setSearch("");
        setSearchData([]);
        if (data[type]?.length === 0 || !data[type]) {
          const res: any = await dispatch(getStudentFolder(type));

          setData((value) => ({
            ...value,
            [type]: res.data
          }));
        }
      } catch (err) {
        console.error("err", err);
      }
    },
    [data, dispatch]
  );

  useEffect(() => {
    onChangeTab("bidding");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const onSearch = useCallback(
    (text: string) => {
      setSearch(text);

      if (text && data[activeTab].length > 0) {
        const boofer: any[] = [];
        const searchLower = text.toLowerCase();

        data[activeTab].forEach((val: any) => {
          const titleMatch = val?.courseTitle?.toLowerCase()?.indexOf(searchLower) !== -1;
          const tagsMatch = val?.tags?.toLowerCase()?.indexOf(searchLower) !== -1;

          if (titleMatch || tagsMatch) {
            boofer.push(val);
          }
        });

        setSearchData(boofer);
      } else {
        setSearchData([]);
      }
    },
    [activeTab, data]
  );

  const onCheck = useCallback(
    async (val: any) => {
      const arrayLevel = [];

      if (val.ease) {
        arrayLevel.push("10");
      }
      if (val.medium) {
        arrayLevel.push("20");
      }
      if (val.hard) {
        arrayLevel.push("30");
      }
      await dispatch(setLevels(arrayLevel));

      const res: any = await dispatch(getStudentFolder(activeTab));
      setData({
        ...data,
        [activeTab]: res.data
      });
    },
    // Don't need to add data in dependecies!
    // eslint-disable-next-line prettier/prettier
    [activeTab, data, dispatch]
  );

  const onClickExercise = useCallback(
    async (item: any, typeClick?: "exercise" | "course") => {
      const resValid: any = await dispatch(validExercise(item, activeTab));
      if (!resValid) {
        return setIsExpiredUser(true);
      }

      if (activeTab === "bidding") {
        const type = item?.bidPlay
          ? "bid_play"
          : item?.interactive
          ? "interactive-bidding"
          : "bidding";
        let gameId = item?.exId;
        let gameName = item?.exIndex;
        if (typeClick == "course" && item?.exercises?.length) {
          gameId = item?.exercises[0]?.exId;
          gameName = item?.exercises[0]?.exIndex;
        }

        let SEODescription = "";
        if (resValid?.data?.Results?.length) {
          SEODescription = resValid?.data?.Results[0]?.Data?.SEODescription;
        }
        const data = {
          gameId,
          courseId: item?.courseId,
          gameName,
          gameTitle: item?.courseTitle,
          SEODescription,
          type
        };
        // return console.log("data", data);
        localStorage.setItem("bidding", JSON.stringify(data));
        dispatch(setGame(data));

        if (type === "bidding") {
          navigate("/bidding?type=10");
        } else if (type === "interactive-bidding") {
          navigate("/bidding_interactive?type=10");
        } else if (type === "bid_play") {
          navigate("/bidding_interactive?type=10&isBidPlay=true");
        }
      } else if (activeTab === "tricks") {
        let gameId = item?.exIndex;

        if (typeClick == "course" && item?.exercises?.length) {
          gameId = item?.exercises[0]?.exIndex;
        }

        const data = {
          gameId,
          courseId: item?.courseId,
          gameName: item?.courseTitle
        };
        localStorage.setItem("tricks_exercise", JSON.stringify(data));

        dispatch(
          setGameMultiple({
            type_game: "tricks",
            data: {
              gameId,
              courseId: item?.courseId,
              globalGameId: gameId,
              gameName: item?.courseTitle
            }
          })
        );
        navigate("/tricks_play");
      } else if (activeTab === "handPlay") {
        let gameId = item?.exIndex;
        let globalGameId = item?.exId;
        if (typeClick == "course" && item?.exercises?.length) {
          gameId = item?.exercises[0]?.exIndex;
          globalGameId = item?.exercises[0]?.exId;
        }

        const data = {
          gameId,
          courseId: item?.courseId,
          gameName: item?.courseTitle,
          globalGameId
        };
        localStorage.setItem("hand_play_exercise", JSON.stringify(data));
        dispatch(
          setGameMultiple({
            type_game: "handPlay",
            data
          })
        );
        navigate("/hand_play");
      } else if (activeTab === "deffense") {
        let gameId = item?.exIndex;
        let globalGameId = item?.exId;
        if (typeClick == "course" && item?.exercises?.length) {
          gameId = item?.exercises[0]?.exIndex;
          globalGameId = item?.exercises[0]?.exId;
        }

        const data = {
          gameId,
          courseId: item?.courseId,
          gameName: item?.courseTitle,
          globalGameId
        };
        localStorage.setItem("deffense_exercise", JSON.stringify(data));
        dispatch(
          setGameMultiple({
            type_game: "deffense",
            data
          })
        );

        navigate("/deffense_play");
      } else if (activeTab === "defLead") {
        let gameId = item?.exId;
        if (typeClick == "course" && item?.exercises?.length) {
          gameId = item?.exercises[0]?.exId;
        }

        const data = {
          gameId,
          courseId: item?.courseId,
          gameName: item?.courseTitle,
          gameNameId: item?.Name || item?.name
        };
        localStorage.setItem("def_lead_exercise", JSON.stringify(data));
        dispatch(
          setGameMultiple({
            type_game: "def_lead",
            data
          })
        );
        navigate("/def_lead_play");
      } else if (activeTab === "miniBridge") {
        let gameId = item?.exIndex;
        let globalGameId = item?.exId;
        if (typeClick == "course" && item?.exercises?.length) {
          gameId = item?.exercises[0]?.exIndex;
          globalGameId = item?.exercises[0]?.exId;
        }

        const data = {
          gameId,
          courseId: item?.courseId,
          gameName: item?.courseTitle,
          globalGameId
        };
        localStorage.setItem("mini_bridge_exercise", JSON.stringify(data));
        dispatch(
          setGameMultiple({
            type_game: "mini_bridge",
            data
          })
        );
        navigate("/mini_bridge");
      }
    },
    [activeTab, navigate, dispatch]
  );

  return (
    <>
      {showMobile && (
        <StudentFolderMobile
          data={data}
          activeLesson={activeLesson}
          searchData={searchData}
          search={search}
          onClickExercise={onClickExercise}
          onSelect={onChangeTab}
          onSearch={onSearch}
          onCheck={onCheck}
          onChangeLesson={setActiveLesson}
        />
      )}
      {!showMobile && (
        <div className="StudentFolder-screen-wrapper">
          <GameHeader />
          <div className="StudentFolder-wrapper-otr">
            <div className="header-otr">
              <StudentFolderHeader
                activeLesson={activeLesson}
                onChangeLesson={setActiveLesson}
                onSearch={onSearch}
                onCheck={onCheck}
                search={search}
              />
            </div>
            <div className="StudentFolder-wrapper-inr">
              <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                <div className="StudentFolder-sideber">
                  <Accordion
                    defaultActiveKey="0"
                    activeKey={activeTab}
                    onSelect={() => {
                      const myDiv = document.getElementsByClassName("StudentFolder-tabContent-inr");
                      onSearch("");
                      if (myDiv && myDiv.length) {
                        for (let i = 0; i <= myDiv.length; i++) {
                          myDiv[i]?.scrollTo({ top: 0 });
                        }
                      }
                    }}>
                    <Accordion.Item eventKey="bidding">
                      <Accordion.Header onClick={() => onChangeTab("bidding")}>
                        הכרזות
                      </Accordion.Header>
                    </Accordion.Item>
                    <Accordion.Item eventKey="handPlay">
                      <Accordion.Header onClick={() => onChangeTab("handPlay")}>
                        משחק יד
                      </Accordion.Header>
                    </Accordion.Item>
                    <Accordion.Item eventKey="deffense">
                      <Accordion.Header onClick={() => onChangeTab("deffense")}>
                        הגנה
                      </Accordion.Header>
                    </Accordion.Item>
                    <Accordion.Item eventKey="tricks">
                      <Accordion.Header onClick={() => onChangeTab("tricks")}>
                        לקיחות
                      </Accordion.Header>
                    </Accordion.Item>
                    <Accordion.Item eventKey="defLead">
                      <Accordion.Header onClick={() => onChangeTab("defLead")}>
                        הובלות
                      </Accordion.Header>
                    </Accordion.Item>
                    {/* <Accordion.Item eventKey="miniBridge">
                      <Accordion.Header onClick={() => onChangeTab("miniBridge")}>
                        מיני ברידג'
                      </Accordion.Header>
                    </Accordion.Item> */}
                  </Accordion>
                </div>
                <div
                  className={`StudentFolder-tabContent ${
                    activeTab === "bidding" ? "StudentFolder-tabContent-radius" : ""
                  }`}>
                  <div
                    className="StudentFolder-tabContent-inr"
                    style={activeTab === "bidding" ? { borderRadius: "24px 0px 24px 24px" } : {}}>
                    <StudentTable
                      data={searchData?.length > 0 || !!search ? searchData : data[activeTab]}
                      activeLesson={activeLesson}
                      onClickExercise={onClickExercise}
                    />
                    <ModalExpiredGame
                      visible={isExpiredUser}
                      onClose={() => setIsExpiredUser(false)}
                      type="studentFolder"
                    />
                  </div>
                </div>
              </Tab.Container>
            </div>
          </div>
          <MainFooterComponent />
        </div>
      )}
    </>
  );
}

export default StudentFolder;
